var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleInterview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -2 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-470.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_schedule_interview",
    transform: "translate(468.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.0412598 C11.5401001,18.0412598 11.1662598,17.6674195 11.1662598,17.2075195 L11.1662598,12 C11.1662598,11.5401001 11.5401001,11.1662598 12,11.1662598 C12.4598999,11.1662598 12.8337402,11.5401001 12.8337402,12 L12.8337402,17.2087402 C12.8337402,17.6686402 12.4598999,18.0412598 12,18.0412598 Z",
    id: "Path",
    fill: "#A3C7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,4.5 L4.5,4.5 C3.12121578,4.5 2,5.62121578 2,7 L2,19.5 C2,20.8787842 3.12121578,22 4.5,22 L19.5,22 C20.8787842,22 22,20.8787842 22,19.5 L22,7 C22,5.62121578 20.8787842,4.5 19.5,4.5 Z M20.3337402,19.5 C20.3337402,19.9598999 19.9598999,20.3337402 19.5,20.3337402 L4.5,20.3337402 C4.04010008,20.3337402 3.66625977,19.9598999 3.66625977,19.5 L3.66625977,10.3663941 L20.3325195,10.3663941 L20.3325195,19.5 L20.3337402,19.5 Z",
    id: "Shape",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.332520, 2.000000)",
    fill: "#A3C7F6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66748047,0 L0.833740234,0 C0.373840313,0 0,0.372619609 0,0.833740234 L0,4.16748047 C0,4.62738039 0.372619609,5.0012207 0.833740234,5.0012207 L1.66748047,5.0012207 C2.12738039,5.0012207 2.5012207,4.62860109 2.5012207,4.16748047 L2.5012207,0.833740234 C2.5012207,0.372619609 2.12738039,0 1.66748047,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5012207,0 L11.6674805,0 C11.2075805,0 10.8337402,0.372619609 10.8337402,0.833740234 L10.8337402,4.16748047 C10.8337402,4.62738039 11.2075805,5 11.6674805,5 L12.5012207,5 C12.9611206,5 13.3349609,4.62738039 13.3349609,4.16625977 L13.3349609,0.833740234 C13.3337402,0.372619609 12.9611206,0 12.5012207,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94873047,13.7088012 C10.0460816,13.9361572 10.0036621,14.2025757 9.83367922,14.3838501 L7.12493898,17.3001098 C7.00744625,17.4273681 6.84112547,17.5 6.66748047,17.5 C6.49383547,17.5 6.32751469,17.4273681 6.20880125,17.3001098 L3.50006102,14.3838501 C3.38989258,14.2663574 3.33374023,14.1125488 3.33374023,13.9587402 C3.33374023,13.8739014 3.35113523,13.789978 3.38623047,13.7088012 C3.48510742,13.4811402 3.71002195,13.3337402 3.95874023,13.3337402 L9.375,13.3337402 C9.62493898,13.3337402 9.84985352,13.4811402 9.94873047,13.7088012 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleInterview);
export default __webpack_public_path__ + "static/media/schedule-interview.e9761d81127974a71327010a0928368a.svg";
export { ForwardRef as ReactComponent };